package fr.frux.shared.domain.model

/**
 * Domain model for a user.
 */
data class User(
    val id: Long,
    val username: String,
    val email: String,
    val createdAt: Long
)
